import Vue from 'vue'
import App from './App.vue'
import Ripple from 'vue-ripple-directive'
import router from './router/router'
import store from './vuex/store'

import 'bootstrap/dist/css/bootstrap-reboot.min.css';
import 'bootstrap/dist/css/bootstrap-grid.min.css';
//import './assets/fonts/icomoon/style.css'
import './assets/fonts/manrope/style.css'
import './assets/styles/layout.scss'
import './assets/styles/default.scss'

Vue.config.productionTip = false

Ripple.color = 'rgba(255, 255, 255, 0.35)';
Vue.directive('ripple', Ripple);


import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

new Vue({
  render: h => h(App),
  store,
  router
}).$mount('#app')
